
import { Link, useNavigate } from 'react-router';
import { useEffect } from 'react';

import { Button } from '@/components/ui/button';

import {
  AuthTemplate,
  FooterLinks,
} from '@/pages/unauthenticated/auth/components';
import { useGetAppContext } from '@/services/context/queries';

export function VerifyAccount({ email }: { email: string }) {
  const navigate = useNavigate();
  const { data: appContext, isLoading } = useGetAppContext();

  const user = appContext?.user;

  useEffect(() => {
    if (isLoading) return;
    if (user && user.email !== email) {
      navigate('/logout', { replace: true });
      return;
    }
    if (user && !user.emailVerified) {
      navigate('/register/thank-you', { replace: true });
    }
  }, [isLoading, user, email, navigate]);

  if (isLoading) return null;

  return (
    <AuthTemplate
      heading="Your account is now verified"
      subheading="Thanks for choosing FlagSync!"
      footer={<FooterLinks />}
    >
      <div className="space-y-4">
        {user ? (
          <Button className="w-full mt-2" asChild>
            <Link to="/dashboard">Take me to the dashboard</Link>
          </Button>
        ) : (
          <Button className="w-full mt-2" asChild>
            <Link to="/login">Sign in</Link>
          </Button>
        )}
      </div>
    </AuthTemplate>
  );
}
